<style>
  .topbar-box{
    background-color: #f8f8f8;
    border-bottom: 1px solid #e7e7e7;
    height: 59px;
  }
  .topbar-box .logo{
    display: inline-block;
    color: white;
    font-size: 20px;
    line-height: 60px;
    margin-left: 33px;
    color: #777;
  }
  .topbar-box .other-box{
    float: right;
    font-size: 16px; 
    margin: 0 30px;
    position: relative;
  }
 .topbar-box .user{
   margin-right: 30px;
   font-size: 14px;
 }
 .el-popper[x-placement^=bottom] .popper__arrow{
   display: none !important;
 }
 .el-dropdown-menu{
    top: 40px !important;
    min-width: 150px;
 }
</style>
<template>
  <div class="topbar-box">
    <div class="logo">
      <span class="name">短信平台后台管理系统</span>
    </div>
    <div class="other-box">
      <span class="el-icon-star-on user"> {{userInfo.username}} </span>
      <span class="el-icon-message user"> 剩余短信： {{$store.state.smsBalanceSize}} 条 </span>
      <el-dropdown trigger="click" @command="handleCommand">
        <el-button type="primary" style="padding:8px 12px">
          <i class="el-icon-setting"></i>&nbsp;管理<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="ul">
          <el-dropdown-item style="border-bottom:1px solid #e5e5e5" command='1'>修改密码</el-dropdown-item>
          <el-dropdown-item style="border-bottom:1px solid #e5e5e5" command='2'>修改绑定电话</el-dropdown-item>
           <el-dropdown-item v-if="isChildAccount" style="border-bottom:1px solid #e5e5e5" command='3'>获取秘钥</el-dropdown-item>
          <el-dropdown-item style="border-bottom:1px solid #e5e5e5" command='4'>设置短信预警</el-dropdown-item>
          <el-dropdown-item command='5'>退出</el-dropdown-item>   
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <revise v-if='show' @colsePass='close'></revise>
    <revisePhone v-if='phoneShow' @colsePhone='closePhone'></revisePhone>
    <key v-if='secretkeyShow' @colseKey='closeKey'></key>
    <warning v-if='warningShow' @colseWarning='closeWarning'></warning>
 </div>
</template>
<script>
  import api from '../../server/api'
  import revise from './revisePass'
  import revisePhone from './revisePhone'
  import key from './secretkey'
  import warning from './warning'
  export default {
    data() {
      return {
        isActive: false,
        userInfo:'132132132',
        show: false,
        phoneShow: false,
        secretkeyShow: false,
        warningShow:false,
        isChildAccount : false
      };
    },
    created() {
      this.userInfo = JSON.parse(localStorage.getItem("USER"));
      this.getSmsBalanceSize();
      if(this.userInfo.childAccount){
          this.isChildAccount = true;
      }
    },
    methods: {
      getSmsBalanceSize(){
        api.getUserInfo({params:{}}).then(res => {
          if(res.status == 'success'){
            this.$store.state.smsBalanceSize = res.data.smsBalanceSize;
            this.$store.state.balanceSizeWarn = res.data.balanceSizeWarn;
          }
        })
      },
      handleCommand(command){
        if(command == 1){
          this.show = true;
        }else if(command == 2){
          this.phoneShow = true;
        }else if(command == 3){
          this.secretkeyShow = true;
        }else if(command == 4){
          this.warningShow = true;
        }else{
          api.logout({data:{}}).then(res => {
            if(res.status == "success"){
              this.$router.push({ path: '/index' });
              localStorage.removeItem('USER');
            }
          })
          // this.$store.state.loginInfo = '';
          // this.$router.push({path: '/index'});
          
        }
      },
      close(){
        this.show = false;
      },
      closePhone(){
        this.phoneShow = false;
      },
      closeKey(){
        this.secretkeyShow = false;
      },
      closeWarning(){
        this.warningShow = false;
      }
    },
    components: {
      revise,revisePhone,key,warning
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/layout/topbar.vue